import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MissionService } from '../../../services/mission.service';
import { FlagService } from '../../../shared/services/flag.service';

@Component({
  selector: 'app-detail-refu',
  templateUrl: './detail-refu.component.html',
  styleUrl: './detail-refu.component.scss',
})
export class DetailRefuComponent {
  refuText: String = '';
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DetailRefuComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private missionApi: MissionService,
    private flag: FlagService
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    // Contester le refus de validation de ma mission N° 84  /missions/finished/contestRejection"

    this.getMissionRefu();
  }
  getMissionRefu() {
    this.isLoading = true;
    this.missionApi.refuMission(this.data.id).subscribe({
      next: (res) => {
        this.refuText = res?.motifsRefus;
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      },
    });
  }
}
